import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Problem`}</h2>
    <p>{`Data is getting larger, more complex, and moving faster than ever `}{`—`}{` a growth that is largely spurred by the widespread adoption of cloud computing. `}</p>
    <p>{`With so many computers around the world connecting and transmitting data via the cloud, the challenge for developers is how to harness enormous amounts of data in a meaningful way.`}</p>
    <h2>{`Solution Sketch`}</h2>
    <ul>
      <li parentName="ul">{`[solution or solution sketche(s)]`}</li>
    </ul>
    <p>{`(batch data processing with Spark; real-time data processing with Kafka; data catalog)`}</p>
    <h3>{`Constraints / Limitations`}</h3>
    <ul>
      <li parentName="ul">{`[limits to approach]`}</li>
    </ul>
    <h3>{`Key OSS Techs`}</h3>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://spark.apache.org/"
        }}>{`Spark`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://kafka.apache.org/"
        }}>{`Kafka`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://flink.apache.org/"
        }}>{`Flink`}</a></li>
    </ul>
    <h3>{`Example Cloud(s)`}</h3>
    <ul>
      <li parentName="ul">{`[at least two public clouds as examples]`}</li>
      <li parentName="ul">{`[list services and features used for solutions]`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`IBM Cloud`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`GCP`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`AWS`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Azure`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Operator`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://www.ibm.com/cloud/analytics-engine"
            }}>{`Analytics Engine`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://cloud.google.com/dataproc/"
            }}>{`Dataproc`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://aws.amazon.com/emr/spark/features/"
            }}>{`EMR`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://azure.microsoft.com/en-us/services/hdinsight/"
            }}>{`HDInsight`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/GoogleCloudPlatform/spark-on-k8s-operator"
            }}>{`Spark Operator`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://www.ibm.com/cloud/event-streams"
            }}>{`Event Streams`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://cloud.google.com/pubsub/"
            }}>{`Pub/Sub`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://aws.amazon.com/msk/"
            }}>{`MSK`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://azure.microsoft.com/en-us/services/event-hubs/"
            }}>{`Event Hubs`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/banzaicloud/koperator"
            }}>{`Kafka Operator`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://cloud.google.com/dataproc/"
            }}>{`Dataproc`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://github.com/lyft/flinkk8soperator"
            }}>{`Flink Operator`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://www.ibm.com/cloud/sql-query"
            }}>{`SQL Query`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://cloud.google.com/bigquery/"
            }}>{`BigQuery`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://aws.amazon.com/redshift/"
            }}>{`Redshift`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://azure.microsoft.com/en-us/services/synapse-analytics"
            }}>{`Synapse Analytics`}</a></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`n/a`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`Where to Find More?`}</h2>
    <h3>{`Blogs`}</h3>
    <ul>
      <li parentName="ul">{`[list of related videos and articles]`}</li>
    </ul>
    <h3>{`Videos`}</h3>
    <ul>
      <li parentName="ul">{`[list of related videos]`}</li>
    </ul>
    <h3>{`Tutorials`}</h3>
    <ul>
      <li parentName="ul">{`[list of related tutorials]`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      